import * as Yup from 'yup';

export const createIdentityValidationSchema = Yup.object().shape({
  identity: Yup.string().required('Campo obrigatório'),
  policies: Yup.array()
    .required()
    .of(Yup.string())
    .min(1, 'Insira ao menos um perfil'),
  password: Yup.string()
    .required('Campo obrigatório')
    .min(5, 'Senha deve ter no mínimo 5 caracteres'),
});
